/**
 * Rollen-Modell (siehe Vault: 08 – Rollen & Rechte).
 * Enforcement passiert IMMER serverseitig; die UI blendet zusätzlich aus.
 */
export const ROLES = ['adult', 'child', 'guest'];
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
/** Kurzhelfer für häufige Rollen-Checks (Serverseite nutzt diese in der RBAC-Schicht). */
export const isAdult = (role) => role === 'adult';
export const isChild = (role) => role === 'child';
export const isGuest = (role) => role === 'guest';
//# sourceMappingURL=roles.js.map